import React, { useState, useEffect, useRef, useLayoutEffect } from "react";
import { Menu, MenuButton, MenuItem, MenuItems } from "@headlessui/react";
import QRobot from "../../components/home/qRobot";
import CreateFromFile from "../../components/home/createFromFile";
import Benchmarked from "../../components/home/benchmarked";
import { useSelector, useDispatch } from "react-redux";
import { Routes, Route, useNavigate, useLocation ,Outlet} from "react-router-dom";
import { Auth } from "aws-amplify";
import {
  Dialog,
  DialogBackdrop,
  DialogPanel,
  DialogTitle,
  Field
} from "@headlessui/react";
import {
  getSurveysFromAPI,
  getPredefinedSurveysFromAPI,
  addSurveyFromAPI,
  deleteSurveyFromAPI,
} from "../../services/surveyService";
import { getQuestionsFromAPI } from "../../services/questionService";
import { getActiveSurveyProgress } from "../../services/surveyJobInitialize";
import {
  setSurveys,
  setOrganizations,
  setUserSurveys,
  setBenchmarkeds,
  setHomeSelectedTab,
  setCurrentSurvey,
  setQuestions,
  setNewSurvey,
  setSurveyDetailSelectedTab,
  updateTabPath,
  updateTabStates
} from "../../store/actions";

export default function Home() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();

  const themeMode = useSelector((state) => state.themeMode);
  const surveys = useSelector((state) => state.surveys);
  const topMenuTabs = useSelector((state) => state.topMenuTabs);
  const newSurvey = topMenuTabs.tabs.find((tab) => tab.id === topMenuTabs.activeTab).states.newSurvey;
  const homeSelectedTab = topMenuTabs.tabs.find((tab) => tab.id === topMenuTabs.activeTab).states.homeSelectedTab;
  const newSurveyNameFromLM = topMenuTabs.tabs.find((tab) => tab.id === topMenuTabs.activeTab).states.newSurveyNameFromLM;
  const leftMenuVisibility = topMenuTabs.tabs.find(
    (tab) => tab.id === topMenuTabs.activeTab
  ).states.leftMenuVisibility;
  let [token, setToken] = useState("");
  let [selectedFunction, setSelectedFunction] = useState("");
  let [selectedFunctionParam, setSelectedFunctionParam] = useState(null);
  const [showSearchBar, setShowSearchBar] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedFilterItems, setSelectedFilterItems] = useState([]);
  const [clearFilter, setClearFilter] = useState(true);
  const [selectedLabel, setSelectedLabel] = useState(""); // Store selected label
  const [isPopupVisible, setIsPopupVisible] = useState(false);
  const [selectedSurveyId, setSelectedSurveyId] = useState(null);
  const [deleteAllowMenuOpen, setDeleteAllowMenuOpen] = useState(false);
  const [deleteInfoMenuShow, setDeleteInfoMenuShow] = useState(false);
  const [cloneInfoMenuShow, setCloneInfoMenuShow] = useState(false);
  const [newSurveyDialog, setNewSurveyDialog] = useState(false);
  const [filterSearchTerm, setFilterSearchTerm] = useState("")
  const [newSurveyName, setNewSurveyName] = useState("");
  const [surveyStatus, setSurveyStatus] = useState([
    {
      title: "Draft",
      icon: (
        <svg
          className="size-5 mt-1"
          fill="#A1A1A1"
          strokeWidth="1"
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M6.97975 1.07389C3.92356 1.52014 1.50831 3.94118 1.0708 7.0002H2.08287C2.50337 4.49345 4.47822 2.51374 6.9825 2.08599L6.97975 1.07389ZM8.98249 2.08014L8.97974 1.06812C12.055 1.49885 14.4896 3.92773 14.9291 7.0002H13.917C13.4945 4.48183 11.5033 2.4954 8.98249 2.08014ZM9.01467 13.9146C11.5201 13.4879 13.4962 11.5077 13.917 9.00019H14.929C14.4913 12.06 12.0748 14.4815 9.01742 14.9267L9.01467 13.9146ZM2.0829 9.0002C2.50529 11.5176 4.49522 13.5034 7.01468 13.9196L7.01743 14.9317C3.94351 14.4999 1.51022 12.0717 1.07083 9.0002H2.0829Z"
          ></path>
        </svg>
      ),
      checked: false,
    },
    {
      title: "In Progress",
      icon: (
        <svg
          className="size-5 mt-1"
          fill="#5195D7"
          strokeWidth="1"
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M8 14C11.3137 14 14 11.3137 14 8C14 4.68629 11.3137 2 8 2C4.68629 2 2 4.68629 2 8C2 11.3137 4.68629 14 8 14ZM8 15C11.866 15 15 11.866 15 8C15 4.13401 11.866 1 8 1C4.13401 1 1 4.13401 1 8C1 11.866 4.13401 15 8 15Z"
          ></path>
          <path
            d="M 4.5 4.5 L 9 4.5 A 4.5 4.5 0 1 1 0.00022499812500598182 4.54499925000375 Z"
            transform="translate(3.5,3.5)"
          ></path>
        </svg>
      ),
      checked: false,
    },
    {
      title: "Completed",
      icon: (
        <svg
          className="size-5 mt-1"
          fill="#83AF12"
          strokeWidth="1"
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="M8,1C4.1,1,1,4.1,1,8c0,3.9,3.1,7,7,7c3.9,0,7-3.1,7-7C15,4.1,11.9,1,8,1z M8,14c-3.3,0-6-2.7-6-6s2.7-6,6-6s6,2.7,6,6S11.3,14,8,14z"></path>
          <path d="M10.6,6.1L7.5,9.2L5.9,7.6c-0.2-0.2-0.6-0.2-0.8,0s-0.2,0.6,0,0.8l2,2c0.1,0.1,0.3,0.2,0.4,0.2s0.3-0.1,0.4-0.2l3.5-3.5c0.2-0.2,0.2-0.6,0-0.8S10.8,5.8,10.6,6.1z"></path>
        </svg>
      ),
      checked: false,
    },
  ]);

  const [qRobotResults, setQRobotResults] = useState([]);
  const [{ run, steps }, setState] = useState({
    run: true,
    steps: [
      {
        content: <h2>Let's begin our journey!</h2>,
        locale: { skip: <strong>SKIP</strong> },
        placement: "center",
        target: "body"
      },
      {
        content: <h2>This area shows the surveys available to the user.</h2>,
        placement: "bottom",
        target: "#surveys",
        title: "First step"
      },
      {
        content: <h2>In this section, users can upload their files with survey information to generate a new survey.</h2>,
        placement: "bottom",
        target: "#createFromFile",
        title: "Second step"
      },
      {
        content: <h2>In this section, users can generate surveys by utilizing AI assistance.</h2>,
        placement: "bottom",
        target: "#qRobot",
        title: "Third step"
      },
      {
        content: <h2>In this section, users can view surveys that are included in the benchmarked data.</h2>,
        placement: "bottom",
        target: "#benchmarked",
        title: "Fourth step"
      },
      {
        content: <h2>By clicking this card, users can create a new blank survey from scratch.</h2>,
        placement: "bottom",
        target: "#createFromScratch",
        title: "Fifth step"
      },
      {
        content: <h2>By clicking these cards, users can navigate to the detailed view of the selected survey.</h2>,
        placement: "bottom",
        target: "#cardBody",
        title: "Sixth step"
      },
      {
        content: <h2>Users can duplicate the selected survey by clicking this card.</h2>,
        placement: "bottom",
        target: "#cloneSurvey",
        title: "Seventh step"
      },
      {
        content: <h2>Users can delete the selected survey from this section.</h2>,
        placement: "bottom",
        target: "#deleteSurvey",
        title: "Eighth step"
      },
      {
        content: <h2>Users can directly navigate to the "Results" section of the survey detail page by clicking here.</h2>,
        placement: "bottom",
        target: "#resultSurvey",
        title: "Ninth step"
      },
      {
        content: <h2>Users can directly navigate to the "Insight" section of the survey detail page by clicking here.</h2>,
        placement: "bottom",
        target: "#insightSurvey",
        title: "Tenth step"
      },
    ]
  });
const prevResultsRef = useRef([]);

  const defaultDemographicsPage = {
    "name": "Demographics",
    "title": "DEMOGRAPHICS",
    "type": "demographics",
    "elements": [
      {
        "name": "Demographics",
        "type": "panel",
        "elements": [
          {
            "name": "Demographics",
            "type": "html",
            "html": "<h5>Demographics</h5>"
          },
          {
            "name": "Demographics",
            "type": "panel",
            "elements": [
              {
                "name": "",
                "isRequired": true,
                "choices": [
                  {
                    "value": 1,
                    "text": "Financial Services"
                  },
                  {
                    "value": 2,
                    "text": "Insurance"
                  },
                  {
                    "value": 3,
                    "text": "Consulting"
                  },
                  {
                    "value": 4,
                    "text": "Software/Internet"
                  },
                  {
                    "value": 5,
                    "text": "Telecommunications"
                  },
                  {
                    "value": 6,
                    "text": "Manufacturing (non-computers)"
                  },
                  {
                    "value": 7,
                    "text": "Manufacturing (computers)"
                  },
                  {
                    "value": 8,
                    "text": "Retail/Wholesale"
                  },
                  {
                    "value": 9,
                    "text": "Government"
                  },
                  {
                    "value": 10,
                    "text": "Education"
                  },
                  {
                    "value": 11,
                    "text": "Pharmaceuticals"
                  },
                  {
                    "value": 12,
                    "text": "Media/Advertising"
                  },
                  {
                    "value": 13,
                    "text": "Utilities"
                  },
                  {
                    "value": 14,
                    "text": "Hospitality/Travel"
                  },
                  {
                    "value": 15,
                    "text": "Transportation"
                  },
                  {
                    "value": 16,
                    "text": "Food/Beverage"
                  },
                  {
                    "value": 17,
                    "text": "Online retail"
                  },
                  {
                    "value": 18,
                    "text": "Other"
                  },
                  {
                    "value": 19,
                    "text": "Healthcare"
                  }
                ],
                "title": " Which best describes your industry?",
                "type": "dropdown"
              }
            ]
          },
          {
            "name": "Demographics",
            "type": "panel",
            "elements": [
              {
                "name": "",
                "isRequired": true,
                "choices": [
                  {
                    "value": 1,
                    "text": "Less than $10M"
                  },
                  {
                    "value": 2,
                    "text": "$10-$49M"
                  },
                  {
                    "value": 3,
                    "text": "$50M-$99M"
                  },
                  {
                    "value": 4,
                    "text": "$100M-$499M"
                  },
                  {
                    "value": 5,
                    "text": "$500M-$999M"
                  },
                  {
                    "value": 6,
                    "text": "$1B-$4.9B"
                  },
                  {
                    "value": 7,
                    "text": "$5B-$9.9B"
                  },
                  {
                    "value": 8,
                    "text": "Greater than $10B"
                  },
                  {
                    "value": 9,
                    "text": "Don't know"
                  }
                ],
                "title": " What size is your company?",
                "type": "dropdown"
              }
            ]
          }
        ]
      }
    ]
  };

  const handleStatusClick = (status) => {
    // const updatedStatus = [...surveyStatus];
    // updatedStatus[index].checked = !updatedStatus[index].checked; // Tıklanan status'un checked değerini değiştir
    // setSurveyStatus(updatedStatus); // Güncellenmiş statusları state'e set et
    const updatedStatus = surveyStatus.map((item) => {
      if (item.title === status.title) {
        item.checked = !item.checked;
      }
      return item;
    });
    setSurveyStatus(updatedStatus); // Güncellenmiş statusları state'e set et
  };
  const previousSurveyStatus = useRef();
  useEffect(() => {
    // Check if surveyStatus has changed (without stringify)
    if (previousSurveyStatus.current !== surveyStatus) {
      // Filter checked items and get their titles
      const selectedTitles = surveyStatus
        .filter((status) => status.checked)
        .map((status) => status.title);

      // If no selected titles, take all titles
      const allTitles = surveyStatus.map((status) => status.title);
      const finalTitles = selectedTitles.length > 0 ? selectedTitles : allTitles;

      setSelectedFilterItems(selectedTitles); // Update selectedFilterItems
      filterSurveys(finalTitles); // Filter surveys based on titles

      // Update previousSurveyStatus to the latest surveyStatus
      previousSurveyStatus.current = surveyStatus;
    }
  }, [surveyStatus]);
  async function checkAuth() {
    // window.location.reload();
    try {
      const cognitoUser = await Auth.currentAuthenticatedUser();
      const currentSession = await Auth.currentSession();
      await cognitoUser.refreshSession(
        currentSession.refreshToken,
        (err, session) => {
          const { idToken, refreshToken, accessToken } = session;
          getToken(idToken.jwtToken);
        }
      );
    } catch (e) {
      // console.log('Unable to refresh Token', e);
    }
  }

  useEffect(() => {
    getToken();
    if (location.pathname.includes("/")) {
      dispatch(updateTabStates(topMenuTabs.activeTab, 'homeSelectedTab', "Home"));
    }
    if (location.pathname.includes("/benchmarked")) {
      dispatch(updateTabStates(topMenuTabs.activeTab, 'homeSelectedTab', "Benchmarked"));
    } else if (location.pathname.includes("/create-from-file")) {
      dispatch(updateTabStates(topMenuTabs.activeTab, 'homeSelectedTab', "Create From File"));
    } else if (location.pathname.includes("/qrobot-progress")) {
      dispatch(updateTabStates(topMenuTabs.activeTab, 'homeSelectedTab', "Q - Robot Progress"));
    }else if (location.pathname.includes("/q-robot")) {
      dispatch(updateTabStates(topMenuTabs.activeTab, 'homeSelectedTab', "Q - Robot"));
    }else if (location.pathname.includes("/help")) {
      dispatch(updateTabStates(topMenuTabs.activeTab, 'homeSelectedTab', "Help"));
    }  else {
      dispatch(updateTabStates(topMenuTabs.activeTab, 'homeSelectedTab', "Surveys"));
    }
  }, [location.pathname]);

  useEffect(() => {
    if (token.length > 0) {
      if (selectedFunction === "getSurveys") {
        getSurveys();
        getBenchmarkeds();
        getQuestions();
      } else if (selectedFunction === "deleteSurvey") {
        deleteSurvey(selectedFunctionParam);
      } else if (selectedFunction === "cloneSurvey") {
        cloneSurvey(selectedFunctionParam);
      } else if (selectedFunction === "getQuestions") {
        getQuestions();
      }
      setSelectedFunction("");
    }
  }, [token]);

  useEffect(() => {
    setFilteredSurveys(surveys);
    handleSearch();
  }, [surveys]);

  async function getQuestions() {
    await getQuestionsFromAPI(token)
      .then((questions) => {
        dispatch(setQuestions(questions));
      })
      .catch((error) => {
        if (error.message === "Request failed with status code 401") {
            setSelectedFunction("getQuestions");
            checkAuth();
        }
      });
  }

  async function getBenchmarkeds() {
    try {
      const obj = { type: "predefined" };
      const result = await getPredefinedSurveysFromAPI(token, obj);

      dispatch(setBenchmarkeds(result["surveys"]));
      
    } catch (error) {
      if (error?.message === "Request failed with status code 401") {
        setSelectedFunction("getSurveys");
        checkAuth();
      }
    }
  }

  useEffect(() => {
    if (newSurvey) {
      createNewSurvey(newSurveyNameFromLM);
      // dispatch(setNewSurvey(false));
      dispatch(updateTabStates(topMenuTabs.activeTab, 'newSurvey', false));
    }
  }, [newSurvey]);

  const openNewSurveyDialog = () => {
    setNewSurveyDialog(true);
  };

  async function createNewSurvey(survey_name) {
    dispatch(updateTabStates(topMenuTabs.activeTab, 'pageIsLoading', true));
    setNewSurveyDialog(false);
    try {
      const userCognitoInfo = await Auth.currentUserInfo();
      const obj = {
        survey_name: survey_name,
        organization: userCognitoInfo.attributes["custom:org_name"],
        content: {
          firstPageIsStarted: false,
          progressBarShowPageNumbers: true,
          progressBarShowPageTitles: true,
          progressBarType: "pages",
          questionsOnPageMode: "standard",
          showPageTitles: false,
          showProgressBar: "top",
          showQuestionNumbers: "on",
          startSurveyText: "Start Survey",
          width: "1500",
          widthMode: "static",
          pages: [defaultDemographicsPage],
        },
      };
      await addSurveyFromAPI(token, obj)
        .then(async (result) => {
          getSurveys(result.survey_id);
        })
        .catch((error) => {
          if (error.message === "Request failed with status code 401") {
            setSelectedFunction("createNewSurvey");
            setSelectedFunctionParam(survey_name);
            checkAuth();
          }
        });
    } catch (error) {
    }
  }

  async function deleteSurvey(survey_id) {
    dispatch(updateTabStates(topMenuTabs.activeTab, 'pageIsLoading', true));
    try {
      await deleteSurveyFromAPI(token, survey_id)
        .then((result) => {
          dispatch(
            setSurveys(surveys.filter((survey) => survey.ID !== survey_id).sort((a, b) => new Date(b.created_at) - new Date(a.created_at)))
          );
          // dispatch(updateTabStates(topMenuTabs.activeTab, 'surveys', surveys.filter((survey) => survey.ID !== survey_id).sort((a, b) => new Date(b.created_at) - new Date(a.created_at))));
          setDeleteAllowMenuOpen(false);
          setDeleteInfoMenuShow(true);
        })
        .catch((error) => {
          if (error.message === "Request failed with status code 401") {
            setSelectedFunction("deleteSurvey");
            setSelectedFunctionParam(survey_id);
            checkAuth();
          }
        });
    } catch (error) {

    } finally {
      dispatch(updateTabStates(topMenuTabs.activeTab, 'pageIsLoading', false));
    }
  }

  async function getSurveys(new_survey_id) {
    dispatch(updateTabStates(topMenuTabs.activeTab, 'pageIsLoading', true));
    try {
      const result = await getSurveysFromAPI(token);

      result["surveys"].forEach((survey) => {
        survey["responded"] = result["userSurveyItems"].filter(
          (item) => item.survey_id === survey.ID && item.is_completed).length + "/"
          + result["userSurveyItems"].filter((item) => item.survey_id === survey.ID).length + " Responded";
      });
      dispatch(setSurveys(result["surveys"].sort((a, b) => new Date(b.created_at) - new Date(a.created_at))));
      dispatch(setUserSurveys(result["userSurveyItems"]));
      dispatch(setOrganizations(result["organizations"]));
      if (new_survey_id) {
        dispatch(updateTabStates(topMenuTabs.activeTab, 'currentSurvey', result["surveys"].find(survey => survey.ID === new_survey_id)));
        dispatch(updateTabStates(topMenuTabs.activeTab, 'surveyDetailSelectedTab', "Summary"));
        dispatch(updateTabPath(topMenuTabs.activeTab, 'Summary', `/surveys/${new_survey_id}/summary`));
        navigate(`/surveys/${new_survey_id}/summary`);
      }
      
    } catch (error) {
      if (error?.message === "Request failed with status code 401") {
        setSelectedFunction("getSurveys");
        setSelectedFunctionParam(new_survey_id);
        checkAuth();
      }
    } finally {
      dispatch(updateTabStates(topMenuTabs.activeTab, 'pageIsLoading', false));
    }
  }

  async function cloneSurvey(survey) {
    dispatch(updateTabStates(topMenuTabs.activeTab, 'pageIsLoading', true));
    try {
      const obj = {
        survey_name: survey.survey_name + "_Copy",
        organization: survey.organization,
        stages: survey.stages ? survey.stages : null,
        content: survey.content
      };
      await addSurveyFromAPI(token, obj)
        .then((result) => {
          getSurveys(result.survey_id);
          setCloneInfoMenuShow(true)
        })
        .catch((error) => {
           if (error.message === "Request failed with status code 401") {
            setSelectedFunction("cloneSurvey");
            setSelectedFunctionParam(survey);
            checkAuth();
          }
        });
    } catch (error) {
      dispatch(updateTabStates(topMenuTabs.activeTab, 'pageIsLoading', false));
    }
  }

  async function getToken(token) {

      const currentSession = await Auth.currentSession();
      setToken(currentSession.idToken.jwtToken);
      setSelectedFunction("getSurveys");
  }
  const [filteredSurveys, setFilteredSurveys] = useState([]);
  // const [filteredItems, setFilteredItems] = useState([]);

  function classNames(...classes) {
    return classes.filter(Boolean).join(" ");
  }

  const fixDateFormat = (date) => {
    const d = new Date(date);
    const year = d.getFullYear();
    const month = String(d.getMonth() + 1).padStart(2, "0");
    const day = String(d.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };

  const sortOptions = [{ name: "Status", href: "#", current: true }];

  const [tabs, setTabs] = useState([
    {
      name: "Surveys",
      href: "#",
      id:"surveys"
    },
    {
      name: "Create From File",
      href: "#",
      id:"createFromFile"
    },
    {
      name: "Q - Robot",
      href: "#",
      id:"qRobot"
    },
    {
      name: "Benchmarked",
      href: "#",
      id:"benchmarked"
    },
  ]);

  const handleMenuItemClick = (label) => {
    setSelectedLabel(label); // Set selected label for filtering
    setShowSearchBar(true); // Show the search bar
  };

  const togglePopup = () => {
    setIsPopupVisible(!isPopupVisible);
  };

  const handleSearch = () => {
    if (searchTerm !== "") {
      const _items2 = surveys.filter((item) =>
        item.responded.toLowerCase().includes(searchTerm.toLowerCase())
      );
      const _items3 = surveys.filter((item) =>
        item.created_at.toLowerCase().includes(searchTerm.toLowerCase())
      );
      const _items4 = surveys.filter((item) =>
        item.status.toLowerCase().includes(searchTerm.toLowerCase())
      );
      const _items = surveys.filter((item) =>
        item.survey_name.toLowerCase().includes(searchTerm.toLowerCase())
      );
      setFilteredSurveys([
        ...new Set([..._items, ..._items2, ..._items3, ..._items4]),
      ]);
    } else {
      setFilteredSurveys(surveys);
    }
  };

  useEffect(() => {
    handleSearch();
  }, [searchTerm]);

  const filterSurveys = (selectedStatuses) => {
    const filtered = surveys.filter((survey) =>
      selectedStatuses.includes(survey.status)
    );
    setFilteredSurveys(filtered);
  };
  const tabMenuClickHandler = (tabName) => {
    // dispatch(setHomeSelectedTab(tabName));
    dispatch(updateTabStates(topMenuTabs.activeTab, 'homeSelectedTab', tabName));
    if (tabName === "Create From File") {
      dispatch(updateTabPath(topMenuTabs.activeTab, 'Create From File', `/home/create-from-file`));
      navigate("/home/create-from-file");
    } else if (tabName === "Q - Robot") {
      dispatch(updateTabPath(topMenuTabs.activeTab, 'Q - Robot', `/home/q-robot`));
      navigate("/home/q-robot");
    } else if (tabName === "Benchmarked") {
      dispatch(updateTabPath(topMenuTabs.activeTab, 'Benchmarked', `/home/benchmarked`));
      navigate("/home/benchmarked");
    } else {
      dispatch(updateTabPath(topMenuTabs.activeTab, 'Home', `/home`));
      navigate("/home");
    }
  };
  const surveyCard = useRef(null);
  const [surveyCardHeight, setSurveyCardHeight] = useState(0);
  const [surveyCardWidth, setSurveyCardWidth] = useState(0);
  const targetDivRef = useRef(null);

  useLayoutEffect(() => {
    // Sayfa render edildikten sonra surveyCard boyutlarını alalım
    if (surveyCard.current) {
      setSurveyCardHeight(surveyCard.current.offsetHeight);
      setSurveyCardWidth(surveyCard.current.offsetWidth);
    }
  }, []); // Yalnızca ilk render sonrası çalışacak

  useLayoutEffect(() => {
    if (targetDivRef.current && surveyCardHeight && surveyCardWidth) {
      targetDivRef.current.style.height = `${surveyCardHeight}px`;
      targetDivRef.current.style.width = `${surveyCardWidth}px`;
    }
  }, [surveyCardHeight, surveyCardWidth]);
  useEffect(() => {
    if (deleteInfoMenuShow) {
      // Sadece dialog açıksa zamanlayıcı başlat
      const timer = setTimeout(() => {
        setDeleteInfoMenuShow(false);
      }, 3000);

      return () => clearTimeout(timer);
    }
  }, [deleteInfoMenuShow]); // Gereksiz çift eklenen bağımlılığı kaldırdım.

  const handleCardClick = (item, page = "summary") => {
    const targetUrl = `/surveys/${item.ID}/summary`;
    // Only dispatch and navigate if the current survey is different
    if (location.pathname !== targetUrl) {
      dispatch(updateTabStates(topMenuTabs.activeTab, 'currentSurvey', item));
      dispatch(updateTabStates(topMenuTabs.activeTab, 'surveyDetailSelectedTab', 'Summary'));
      dispatch(updateTabPath(topMenuTabs.activeTab, 'Summary', `/surveys/${item.ID}/summary`));
      navigate(`/surveys/${item.ID}/` + page);
    }
    else {
      return;
    }
  };

  // useEffect(() => {
  //   if (token.length == 0) return;

  //   getSurveyProgress();

  //   const interval = setInterval(() => {
  //     getSurveyProgress();
  //   }, 5000);

  //   return () => {
  //     clearInterval(interval);
  //   };
  // }, [token]);


// async function getSurveyProgress() {
//   const results = await getActiveSurveyProgress(token, "qrobot");
//   console.log("results",results)
//   setQRobotResults(results);

// }
// useEffect(()=>{
//   const prevResults = prevResultsRef.current;

//   // running -> completed olan var mı?
//   const hasJustCompleted = qRobotResults.some(newItem => {
//     const prevItem = prevResults.find(
//       p => p.job_id === newItem.job_id
//     );

//     return (
//       prevItem &&
//       prevItem.status.toLowerCase() === "running" &&
//       newItem.status.toLowerCase() === "completed"
//     );
//   });

//   prevResultsRef.current = qRobotResults;
//   if (hasJustCompleted) {
//     getSurveys()
//   }
// },[qRobotResults])


  const ProgressBar = ({ value }) => {
    const safeValue = Math.min(Math.max(value ?? 0, 0), 100);

    return (
      <div className="w-full mt-2">
        <div className="w-full h-2 bg-gray-200 rounded-full overflow-hidden">
          <div
            className="h-2 bg-[#5195D7] transition-all duration-300"
            style={{ width: `${safeValue}%` }}
          />
        </div>
        <div className="text-[0.65rem] text-right mt-1 text-gray-500">
          %{safeValue}
        </div>
      </div>
    );
  };

  return (
    <div
      className={`home-container ${themeMode === "dark" ? "dark-theme" : "light-theme"
        } flex flex-1 flex-col`}
    >
      <div className="flex flex-col  justify-start h-auto pt-2  px-3 py-0 border-b border-[#ffffff0f] text-white lg:items-center xl:items-center sm:flex-col md:flex-col sm:pt-2 md:pt-2 lg:pt-0 xl:pt-0 lg:flex-row xl:flex-row md:h-auto sm:h-auto lg:h-[3.5rem] xl:h-[3.5rem] md:justify-start sm:justify-start">
        <div className="flex mr-2 pr-5 w-full gap-[0.25rem] border-0 border-[#ffffff0f] flex-col sm:flex-row md:flex-row lg:flex-row xl:flex-row sm:border-0 md:border-0 lg:border-r xl:border-r sm:w-full md:w-full lg:w-auto xl:w-auto">
          {tabs.find((tab) => tab.name === homeSelectedTab)?.name === "Surveys" && (
            <div className="flex items-center">
              <Menu as="div">
                <div>
                  <MenuButton
                    className={`flex items-center self-stretch p-0 pr-1 h-[2rem] min-w-8  rounded-md shadow-inner border border-[#ffffff17]  ${themeMode === "dark"
                      ? "bg-[#ffffff05] hover:bg-[#ffffff0a]"
                      : "bg-black-02 shadow-[0_0_0_1px_rgba(0,0,0,0.09)]"
                      } `}
                  >
                    {selectedFilterItems.length !== 0 ? (
                      <div
                        onClick={(e) => {
                          e.stopPropagation();
                          setSelectedFilterItems([]);
                          setFilteredSurveys(surveys);
                          setSurveyStatus(
                            surveyStatus.map((status) => {
                              status.checked = false;
                              return status;
                            })
                          );
                        }} // Reset search term to empty string

                        className={`flex items-center justify-center gap-3 p-0 px-3 cursor-pointer bg-transparent border border-transparent rounded-md text-sm  min-w-[1.375rem] whitespace-nowrap transition-all duration-150 hover:bg-black-200 hover:border-black-900  ${themeMode === "dark"
                          ? "hover:text-[#fff] text-white"
                          : "hover:text-[#000] text-black-8"
                          }`}
                      >
                        <div
                          className={`btn-icon pointer-events-none ${themeMode === "dark" ? "text-white-8" : "text-black-8"
                            }`}
                        >
                          <svg
                            className="svg-small w-[.8rem] h-[.8rem] mr-1"
                            fill="currentColor"
                            viewBox="0 0 16 16"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path d="M8.7,8l4.6-4.6c0.2-0.2,0.2-0.5,0-0.7s-0.5-0.2-0.7,0L8,7.3L3.4,2.6c-0.2-0.2-0.5-0.2-0.7,0s-0.2,0.5,0,0.7L7.3,8l-4.6,4.6c-0.2,0.2-0.2,0.5,0,0.7c0.1,0.1,0.2,0.1,0.4,0.1s0.3,0,0.4-0.1L8,8.7l4.6,4.6c0.1,0.1,0.2,0.1,0.4,0.1s0.3,0,0.4-0.1c0.2-0.2,0.2-0.5,0-0.7L8.7,8z"></path>
                          </svg>
                        </div>
                        <span className="overflow-label label disabled pointer-events-none whitespace-nowrap break-all text-ellipsis overflow-hidden min-w-0">
                          Clear filter
                        </span>
                      </div>
                    ) : (
                      <div
                        className={`flex items-center justify-center gap-3 p-0 px-3 cursor-pointer bg-transparent border border-transparent rounded-md text-sm  min-w-[1.375rem] whitespace-nowrap transition-all duration-150 hover:bg-black-200 hover:border-black-900  ${themeMode === "dark"
                          ? "hover:text-[#fff] text-white"
                          : "hover:text-[#000] text-black-8"
                          }`}
                        type="button"
                        onClick={() => {
                          setFilterSearchTerm("");
                          setShowSearchBar(false);
                          togglePopup();
                        }}
                      >
                        <div className="pointer-events-none">
                          <svg
                            className="w-4 h-4"
                            fill="currentColor"
                            viewBox="0 0 32 32"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path d="M29.9,4.1c-0.1-0.4-0.4-0.8-0.7-1.1c-0.3-0.3-0.7-0.5-1.1-0.7c-0.1,0-0.2-0.1-0.3-0.1H4.2c-0.1,0-0.2,0-0.3,0.1C3.5,2.5,3.1,2.7,2.8,3C2.5,3.3,2.3,3.7,2.1,4.1C2,4.5,2,5,2,5.4c0.1,0.4,0.2,0.8,0.5,1.2c0,0,0.1,0.1,0.1,0.1l8.8,9.7v6.9c0,0.3,0.1,0.6,0.4,0.8l7.3,5.4c0.2,0.1,0.4,0.2,0.6,0.2c0.2,0,0.3,0,0.4-0.1c0.3-0.2,0.6-0.5,0.6-0.9V16.4l8.8-9.7c0,0,0.1-0.1,0.1-0.1c0.2-0.4,0.4-0.8,0.5-1.2C30,5,30,4.5,29.9,4.1z M27.9,5.4l-9,9.9c-0.2,0.2-0.3,0.4-0.3,0.7v10.7l-5.3-3.9V16c0-0.2-0.1-0.5-0.3-0.7l-9-9.9C4.1,5.3,4,5.2,4,5.1C4,5,4,4.9,4,4.8c0-0.1,0.1-0.2,0.2-0.3c0.1-0.1,0.1-0.1,0.2-0.1h23.2c0.1,0,0.1,0.1,0.2,0.1c0.1,0.1,0.2,0.2,0.2,0.3C28,4.9,28,5,28,5.1C28,5.2,27.9,5.3,27.9,5.4z"></path>
                          </svg>
                        </div>
                        <span className="overflow-hidden text-ellipsis whitespace-nowrap ">
                          Filter
                        </span>
                      </div>
                    )}
                  </MenuButton>
                </div>

                <MenuItems
                  transition
                  className={`absolute right-30 z-10 mt-2 w-40 origin-top-right rounded-md shadow-2xl ring-1 ring-black/5 transition focus:outline-none data-[closed]:scale-95 data-[closed]:transform data-[closed]:opacity-0 data-[enter]:duration-100 data-[leave]:duration-75 data-[enter]:ease-out data-[leave]:ease-in  border-solid border-[1px] ${themeMode === "dark"
                    ? " bg-[#2a2939] border-white-09 shadow-theme-popup-shadow "
                    : "bg-[#FFFFFF] border-black-09 shadow-black-2-shadow"
                    }`}
                >
                  <div className="py-1">
                    <div className="px-1 py-2">
                      <input
                        type="text"
                        placeholder="Search..."
                        value={filterSearchTerm}
                        onChange={(e) => setFilterSearchTerm(e.target.value)}
                        className={`w-full px-2 py-1 mb-2 rounded-md ${themeMode === "dark"
                          ? " bg-[#2a2939]  shadow-theme-popup-shadow  placeholder:text-white-6 text-white-6"
                          : "bg-[#FFFFFF] shadow-black-2-shadow placeholder:text-black text-black"
                          }`}
                      />
                      <div className="flex-grow min-h-0 h-max overflow-x-hidden overflow-y-auto">
                        <div className="flex flex-col h-full">
                          {surveyStatus
                            .filter(
                              (status) =>
                                !filterSearchTerm.trim() || // Eğer arama terimi boşsa tüm öğeleri döndür
                                status.title
                                  .toLowerCase()
                                  .includes(filterSearchTerm.toLowerCase())
                            )
                            .map((status, index) => (
                              <button
                                key={index}
                                onClick={() => handleStatusClick(status)}
                                className={`mx-2 cursor-pointer flex-shrink-0 justify-start p-1 px-2 min-w-0 min-h-[2.25rem] text-left ${themeMode === "dark"
                                  ? "text-white bg-[2a2939] hover:bg-[#333240]"
                                  : "text-black bg-[#FFFFFF] hover:bg-[#EBEBEB]"
                                  } rounded`}
                              >
                                <div className="flex justify-between items-center min-w-0 min-h-0 w-full">
                                  <div className="flex items-center justify-between flex-nowrap min-w-0 min-h-0 w-full">
                                    <div
                                      className={`flex items-center ${themeMode === "dark"
                                        ? "text-white"
                                        : "text-black"
                                        } flex-wrap-nowrap min-w-0 cursor-pointer`}
                                    >
                                      <div className="">{status.icon}</div>
                                      <span className="ml-2 whitespace-nowrap break-words truncate overflow-hidden min-w-0">
                                        {status.title}
                                      </span>
                                    </div>
                                    {status.checked && (
                                      <div className="pointer-events-none">
                                        <svg
                                          xmlns="http://www.w3.org/2000/svg"
                                          fill="none"
                                          viewBox="0 0 24 24"
                                          strokeWidth="1.5"
                                          stroke="currentColor"
                                          className="w-4 h-4"
                                        >
                                          <path
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                            d="m4.5 12.75 6 6 9-13.5"
                                          />
                                        </svg>
                                      </div>
                                    )}
                                  </div>
                                </div>
                              </button>
                            ))}
                        </div>
                      </div>
                    </div>
                  </div>
                </MenuItems>
              </Menu>
            </div>)}
          {(tabs.find((tab) => tab.name === homeSelectedTab)?.name === "Surveys" || tabs.find((tab) => tab.name === homeSelectedTab)?.name === "Benchmarked") && (
            <label
              className={`flex items-center self-stretch p-0 pr-1 h-[2rem] min-w-8 border border-[#ffffff17]  rounded-md shadow-inner cursor-text transition-all max-w-8 focus-within:max-w-[15rem] focus-within:pr-1 focus-within:p-0.25 active:max-w-[15rem] active:pr-1 active:p-0.25 ${themeMode === "dark"
                ? "bg-[#ffffff05] hover:bg-[#ffffff0a]"
                : "bg-black-02 shadow-[0_0_0_1px_rgba(0,0,0,0.09)]"
                } ${searchTerm.length > 0 ? "max-w-[15rem]" : "max-w-8"}`}
            >
              <div
                className={`flex items-center justify-center flex-shrink-0 p-0 bg-transparent border-none outline-none cursor-pointer rounded-md h-8 w-8  mr-1 focus-within:cursor-text ${themeMode === "dark" ? "text-white" : "text-[#0f121a]"
                  }`}
              >
                <svg
                  className="w-[1rem] h-[1rem]"
                  fill="currentColor"
                  viewBox="0 0 16 16"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M10.7241 10.0168L14.3535 13.6465C14.5488 13.8417 14.5488 14.1583 14.3535 14.3536C14.1602 14.5469 13.8478 14.5488 13.6522 14.3592L10.017 10.7238C8.9277 11.6312 7.5305 12.0836 6.11608 11.9871C4.70165 11.8905 3.37891 11.2524 2.423 10.2054C1.4671 9.15843 0.951637 7.78323 0.983845 6.36588C1.01605 4.94853 1.59345 3.59816 2.59593 2.59568C3.5984 1.59321 4.94877 1.01581 6.36612 0.983601C7.78347 0.951393 9.15867 1.46686 10.2057 2.42276C11.2526 3.37866 11.8908 4.70141 11.9873 6.11583C12.0839 7.53026 11.6314 8.92745 10.7241 10.0168ZM2.75851 3.99981C2.26404 4.73983 2.00012 5.60986 2.00012 6.49987C2.00144 7.69294 2.47597 8.83677 3.3196 9.68039C4.16323 10.524 5.30705 10.9986 6.50012 10.9999C7.39013 10.9999 8.26016 10.736 9.00018 10.2415C9.7402 9.74702 10.317 9.04422 10.6576 8.22195C10.9982 7.39968 11.0873 6.49488 10.9137 5.62197C10.74 4.74905 10.3114 3.94723 9.6821 3.31789C9.05276 2.68856 8.25094 2.25997 7.37802 2.08634C6.50511 1.91271 5.60031 2.00182 4.77804 2.34242C3.95578 2.68301 3.25297 3.25979 2.75851 3.99981Z"
                  ></path>
                </svg>
              </div>
              <input
                type="text"
                className={`mr-3 p-0 w-full h-full ${themeMode === "dark" ? "text-white" : "placeholder:text-black text-black"} caret-[#2a59d6] bg-transparent border-none outline-none appearance-none`}
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                placeholder="Search"
                autoComplete="off"
                spellCheck="false"
              />
            </label>
          )}
        </div>
        <div className="flex  h-auto gap-2  overflow-x-auto  w-full sm:w-full md:w-full lg:w-auto xl:w-auto sm:overflow-x-auto md:overflow-x-auto lg:overflow-x-visible xl:overflow-x-visible ">
          <div
            className={` block sm:block  -mx-1 flex justify-center  py-2 px-0  sm:px-0 md:px-0 lg:px-4 xl:px-4 `}
          >
            <nav
              aria-label="Tabs"
              className={` flex     w-max flex items-center align-center justify-center flex-nowrap flex-shrink-0 min-w-0 gap-[0.25rem] rounded-[0.375rem]   ${themeMode === "dark" ? "bg-[#a5bdff0d]" : "bg-[#1530720d]"
                }`}
            >
              {tabs.map((tab, index) => (
                <a
                  key={tab.name}
                  href={tab.href}
                  id={tab.id}
                  aria-current={
                    tab.name === homeSelectedTab ? "header" : undefined
                  }
                  onClick={() => tabMenuClickHandler(tab.name)}
                  className={classNames(
                    tab.name === homeSelectedTab
                      ? themeMode === "dark"
                        ? "bg-[#A5BDFF26] text-[#FFFFFF] flex justify-center items-center flex-nowrap flex-shrink-0 rounded-[0.375rem] hover:text-[#FFFFFF]"
                        : "bg-[#A5BDFF26] text-[#5a667e] flex justify-center items-center flex-nowrap flex-shrink-0 rounded-[0.375rem] hover:text-[#000]"
                      : themeMode === "dark"
                        ? "flex justify-center items-center flex-nowrap flex-shrink-0 hover:rounded-[0.375rem] text-[#C1C9D6] hover:bg-[#a5bdff10] hover:text-[#FFFFFF]"
                        : "flex justify-center items-center flex-nowrap flex-shrink-0 hover:rounded-[0.375rem] text-[#5a667e] hover:bg-gray-200 hover-text-[#000]",
                    "group inline-flex items-center py-2 pl-2 pr-2 text-xs sm:text-sm font-medium whitespace-nowrap"
                  )}
                >
                  {/* {tab.icon} */}
                  <span>{tab.name}</span>
                </a>
              ))}
            </nav>
          </div>
        </div>
      </div>
      {tabs.find((tab) => tab.name === homeSelectedTab)?.name === "Surveys" && (
        <div className={`flex flex-wrap overflow-x-hidden max-w-full   items-center   ${leftMenuVisibility=="show" ? 'justify-start xs:justify-center' : 'justify-center'}  gap-12 p-4 sm:pl-6 xs:pl-12 md:pl-12 lg:pl-12 xl:pl-12 mx-auto mt-4`}>
          <div
            ref={targetDivRef}
            id="createFromScratch"
            className={`shadow-md rounded-lg pt-2 px-0 pb-0 w-1/6  w-[250px] sm:w-[300px] h-[200px]   ${themeMode === "dark"
              ? "bg-[#dedef00a] hover:bg-[#282834] text-white cursor-pointer hover:shadow-[0_0_1px_1px_#205DC2] hover:animate-[ease-in-out_1s]"
              : "bg-white text-gray-800 cursor-pointer hover:bg-gray-200 hover:shadow-[0_0_1px_1px_#205DC2]"
              }`}
            onClick={() => openNewSurveyDialog()}
          >
            <div className="p-4 py-1 rounded-lg flex flex-col items-center justify-center">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                strokeWidth="1"
                stroke="currentColor"
                className="size-14 mb-3 mt-4 text-[#205DC2]"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M12 2.25c-5.376 0-9.75 4.374-9.75 9.75s4.374 9.75 9.75 9.75 9.75-4.374 9.75-9.75S17.376 2.25 12 2.25zm0 12.75l4-4m-4 4l-4-4m8 0H8"
                />
              </svg>
              <p className="text-sm font-semibold">Create from Scratch</p>
              <p className="text-xs text-gray-500">Start with a blank survey</p>
            </div>
          </div>
          {qRobotResults
            .filter(item => item.status !== "completed")
            .map(item => (
                 <div
              ref={surveyCard}
              key={item.survey_id}
              id="cardBody"
              className={`shadow-md  rounded-lg pt-2 px-0 pb-0 w-[250px] sm:w-[300px] h-[200px]  flex justify-between flex-col ${themeMode === "dark"
                  ? "bg-[#dedef00a] hover:bg-[#282834] text-white cursor-pointer hover:shadow-[0_0_1px_1px_#205DC2] hover:animate-[ease-in-out_1s]"
                  : "bg-white text-gray-800 cursor-pointer hover:bg-gray-100 hover:shadow-[0_0_1px_1px_#205DC2]"
                }`}
            >
              <div className="p-1 py-1 rounded-lg sm:p-1 md:p-4 lg:p-4 xl:p-4 flex flex-grow flex-col">
                <div className="flex justify-between  items-center mb-3">
                  {item.status === "Draft" && (
                    <div className="flex items-center">
                      <svg
                        className="size-5 mt-1"
                        fill="#A1A1A1"
                        strokeWidth="1"
                        viewBox="0 0 24 24"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M6.97975 1.07389C3.92356 1.52014 1.50831 3.94118 1.0708 7.0002H2.08287C2.50337 4.49345 4.47822 2.51374 6.9825 2.08599L6.97975 1.07389ZM8.98249 2.08014L8.97974 1.06812C12.055 1.49885 14.4896 3.92773 14.9291 7.0002H13.917C13.4945 4.48183 11.5033 2.4954 8.98249 2.08014ZM9.01467 13.9146C11.5201 13.4879 13.4962 11.5077 13.917 9.00019H14.929C14.4913 12.06 12.0748 14.4815 9.01742 14.9267L9.01467 13.9146ZM2.0829 9.0002C2.50529 11.5176 4.49522 13.5034 7.01468 13.9196L7.01743 14.9317C3.94351 14.4999 1.51022 12.0717 1.07083 9.0002H2.0829Z"
                        ></path>
                      </svg>
                      <span className="size-5 whitespace-nowrap text-xs text-[#A1A1A1]">
                        {item.status}
                      </span>
                    </div>
                  )}
                  {item.status.toLowerCase() === "running" && (
                    <div className="flex items-center">
                      <svg
                        className="size-5 mt-1"
                        fill="#5195D7"
                        strokeWidth="1"
                        viewBox="0 0 24 24"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M8 14C11.3137 14 14 11.3137 14 8C14 4.68629 11.3137 2 8 2C4.68629 2 2 4.68629 2 8C2 11.3137 4.68629 14 8 14ZM8 15C11.866 15 15 11.866 15 8C15 4.13401 11.866 1 8 1C4.13401 1 1 4.13401 1 8C1 11.866 4.13401 15 8 15Z"
                        ></path>
                        <path
                          d="M 4.5 4.5 L 9 4.5 A 4.5 4.5 0 1 1 0.00022499812500598182 4.54499925000375 Z"
                          transform="translate(3.5,3.5)"
                        ></path>
                      </svg>
                      <span className="size-5 whitespace-nowrap text-xs text-[#5195D7]">
                        {item.status
                          ? item.status.charAt(0).toUpperCase() + item.status.slice(1).toLowerCase()
                          : ""}

                      </span>
                    </div>
                  )}
                </div>
                <p
                  className="text-sm font-semibold mb-4 line-clamp-1"
                  title={item.survey_name}
                >
                  {item.survey_name}
                </p>
                <p className="text-[0.70rem] mb-1">
                  <span>Created: </span>
                  {fixDateFormat(item.started_at)}
                </p>
                <p className="text-[0.70rem] mb-1">{item.responded}</p>
              </div>
              <div
                className={`flex rounded-b-lg items-center justify-between  mt-auto  w-full ${themeMode === "dark" ? "bg-[#d9d9d912]" : "bg-[#2a2a2a12]"
                  }`}
              >
                <ProgressBar value={item.progress} />
              </div>
            </div>
          ))}
          {filteredSurveys.map((item) => (
            <div
              ref={surveyCard}
              key={item.ID}
              id="cardBody"
              className={`shadow-md  rounded-lg pt-2 px-0 pb-0 w-[250px] sm:w-[300px] h-[200px]  flex justify-between flex-col ${themeMode === "dark"
                  ? "bg-[#dedef00a] hover:bg-[#282834] text-white cursor-pointer hover:shadow-[0_0_1px_1px_#205DC2] hover:animate-[ease-in-out_1s]"
                  : "bg-white text-gray-800 cursor-pointer hover:bg-gray-100 hover:shadow-[0_0_1px_1px_#205DC2]"
                }`}
              onClick={() => handleCardClick(item)}

            >
              <div className="p-1 py-1 rounded-lg sm:p-1 md:p-4 lg:p-4 xl:p-4 flex flex-grow flex-col">
                <div className="flex justify-between  items-center mb-3">
                  {item.status === "Draft" && (
                    <div className="flex items-center">
                      <svg
                        className="size-5 mt-1"
                        fill="#A1A1A1"
                        strokeWidth="1"
                        viewBox="0 0 24 24"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M6.97975 1.07389C3.92356 1.52014 1.50831 3.94118 1.0708 7.0002H2.08287C2.50337 4.49345 4.47822 2.51374 6.9825 2.08599L6.97975 1.07389ZM8.98249 2.08014L8.97974 1.06812C12.055 1.49885 14.4896 3.92773 14.9291 7.0002H13.917C13.4945 4.48183 11.5033 2.4954 8.98249 2.08014ZM9.01467 13.9146C11.5201 13.4879 13.4962 11.5077 13.917 9.00019H14.929C14.4913 12.06 12.0748 14.4815 9.01742 14.9267L9.01467 13.9146ZM2.0829 9.0002C2.50529 11.5176 4.49522 13.5034 7.01468 13.9196L7.01743 14.9317C3.94351 14.4999 1.51022 12.0717 1.07083 9.0002H2.0829Z"
                        ></path>
                      </svg>
                      <span className="size-5 whitespace-nowrap text-xs text-[#A1A1A1]">
                        {item.status}
                      </span>
                    </div>
                  )}
                  {item.status === "In Progress" && (
                    <div className="flex items-center">
                      <svg
                        className="size-5 mt-1"
                        fill="#5195D7"
                        strokeWidth="1"
                        viewBox="0 0 24 24"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M8 14C11.3137 14 14 11.3137 14 8C14 4.68629 11.3137 2 8 2C4.68629 2 2 4.68629 2 8C2 11.3137 4.68629 14 8 14ZM8 15C11.866 15 15 11.866 15 8C15 4.13401 11.866 1 8 1C4.13401 1 1 4.13401 1 8C1 11.866 4.13401 15 8 15Z"
                        ></path>
                        <path
                          d="M 4.5 4.5 L 9 4.5 A 4.5 4.5 0 1 1 0.00022499812500598182 4.54499925000375 Z"
                          transform="translate(3.5,3.5)"
                        ></path>
                      </svg>
                      <span className="size-5 whitespace-nowrap text-xs text-[#5195D7]">
                        {item.status}
                      </span>
                    </div>
                  )}
                  {item.status === "Completed" && (
                    <div className="flex items-center">
                      <svg
                        className="size-5 mt-1"
                        fill="#83AF12"
                        strokeWidth="1"
                        viewBox="0 0 24 24"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path d="M8,1C4.1,1,1,4.1,1,8c0,3.9,3.1,7,7,7c3.9,0,7-3.1,7-7C15,4.1,11.9,1,8,1z M8,14c-3.3,0-6-2.7-6-6s2.7-6,6-6s6,2.7,6,6S11.3,14,8,14z"></path>
                        <path d="M10.6,6.1L7.5,9.2L5.9,7.6c-0.2-0.2-0.6-0.2-0.8,0s-0.2,0.6,0,0.8l2,2c0.1,0.1,0.3,0.2,0.4,0.2s0.3-0.1,0.4-0.2l3.5-3.5c0.2-0.2,0.2-0.6,0-0.8S10.8,5.8,10.6,6.1z"></path>
                      </svg>
                      <span className="size-5 whitespace-nowrap text-xs text-[#83AF12]">
                        {item.status}
                      </span>
                    </div>
                  )}
                  <div className="flex items-center">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                      strokeWidth="1"
                      stroke="currentColor"
                      id="cloneSurvey"
                      onClick={(e) => {
                        e.stopPropagation();
                        cloneSurvey(item);
                      }}
                      className={`size-6 rounded p-1 cursor-pointer ${themeMode === "dark" ? "hover:bg-[#b3b1b112]" : "hover:bg-[#2a2a2a12]"}`}
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M15.75 17.25v3.375c0 .621-.504 1.125-1.125 1.125h-9.75a1.125 1.125 0 0 1-1.125-1.125V7.875c0-.621.504-1.125 1.125-1.125H6.75a9.06 9.06 0 0 1 1.5.124m7.5 10.376h3.375c.621 0 1.125-.504 1.125-1.125V11.25c0-4.46-3.243-8.161-7.5-8.876a9.06 9.06 0 0 0-1.5-.124H9.375c-.621 0-1.125.504-1.125 1.125v3.5m7.5 10.375H9.375a1.125 1.125 0 0 1-1.125-1.125v-9.25m12 6.625v-1.875a3.375 3.375 0 0 0-3.375-3.375h-1.5a1.125 1.125 0 0 1-1.125-1.125v-1.5a3.375 3.375 0 0 0-3.375-3.375H9.75"
                      />
                    </svg>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                      strokeWidth="1"
                      stroke="currentColor"
                      id="deleteSurvey"
                      onClick={(e) => {
                        e.stopPropagation();
                        setSelectedSurveyId(item.ID);
                        setDeleteAllowMenuOpen(true);
                      }}
                      className={`size-6 rounded p-1 cursor-pointer ${themeMode === "dark" ? "hover:bg-[#b3b1b112]" : "hover:bg-[#2a2a2a12]"}`}
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="m14.74 9-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 0 1-2.244 2.077H8.084a2.25 2.25 0 0 1-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 0 0-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 0 1 3.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 0 0-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 0 0-7.5 0"
                      />
                    </svg>
                  </div>
                </div>
                <p
                  className="text-sm font-semibold mb-4 line-clamp-1"
                  title={item.survey_name}
                >
                  {item.survey_name}
                </p>
                <p className="text-[0.70rem] mb-1">
                  <span>Created: </span>
                  {fixDateFormat(item.created_at)}
                </p>
                <p className="text-[0.70rem] mb-1">{item.responded}</p>
              </div>
              <div
                className={`flex rounded-b-lg items-center justify-between  mt-auto  w-full ${themeMode === "dark" ? "bg-[#d9d9d912]" : "bg-[#2a2a2a12]"
                  }`}
              >
                <div
                  className={`p-3 w-full text-center rounded  ${item.status == "Draft"
                    ? "text-gray-500 cursor-default"
                    : "hover:bg-[#b3b1b112]"
                    }`}
                    id="resultSurvey"
                  onClick={(e) => {
                    e.stopPropagation();
                    handleCardClick(item, "results");
                  }}
                >
                  RESULTS
                </div>
                <div
                  className={`p-3 w-full text-center rounded ${item.status != "Completed"
                    ? "text-gray-500 cursor-default"
                    : "hover:bg-[#b3b1b112]"
                    }`}
                    id="insightSurvey"
                  onClick={(e) => {
                    e.stopPropagation();
                    handleCardClick(item, "insight-summary");
                  }}
                >
                  INSIGHT
                </div>
              </div>
            </div>
          ))}
          <Dialog
            open={deleteAllowMenuOpen}
            onClose={setDeleteAllowMenuOpen}
            className="relative z-10"
          >
            <DialogBackdrop
              transition
              className="fixed inset-0  transition-opacity data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in"
            />

            <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
              <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
                <DialogPanel
                  transition
                  className={`relative transform  rounded-lg shadow-black-2-shadow border border-solid ${themeMode === "dark"
                    ? "bg-[#2a2939] border-white-09"
                    : "bg-[#FFFFFF] border-black-09 "
                    } overflow-hidden rounded-lg   px-4 pb-4 pt-5 text-left shadow-xl transition-all data-[closed]:translate-y-4 data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in sm:my-8 sm:w-full sm:max-w-lg sm:p-6 data-[closed]:sm:translate-y-0 data-[closed]:sm:scale-95`}
                >
                  <div>
                    <div className="mt-0 text-start sm:mt-0">
                      <DialogTitle
                        as="h3"
                        className={`text-base font-semibold ${themeMode === "dark" ? "text-[#fff]" : "text-[#000]"
                          }`}
                      >
                        Delete Selected Survey
                      </DialogTitle>
                      <div className="mt-1">
                        <p
                          className={`text-sm ${themeMode === "dark"
                            ? "text-white-8"
                            : "text-black-8"
                            }`}
                        >
                          Are you sure you want to delete this survey
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="flex-shrink-0 grid grid-flow-col rtl justify-end items-center gap-2 mt-2">
                    <button
                      type="button"
                      onClick={() => deleteSurvey(selectedSurveyId)}
                      className={`mt-3 inline-flex justify-center rounded-[0.375rem] border-solid bg-[#205dc2] hover:bg-[#3575de] hover:text-white text-white  ${themeMode === "dark"
                        ? " border-white-09  "
                        : " border-black-09 "
                        } px-3 py-2 text-sm font-semibold shadow-sm sm:col-start-2 sm:mt-0`}
                    >
                      Yes
                    </button>
                    <button
                      type="button"
                      data-autofocus
                      onClick={() => setDeleteAllowMenuOpen(false)}
                      className={`mt-3 inline-flex justify-center rounded-[0.375rem] border-solid ${themeMode === "dark"
                        ? "bg-white-02 border-white-09 text-white-8 hover:text-white hover:bg-white-04"
                        : "bg-black-02 border-black-09 text-black-8 hover:text-black hover:bg-black-04"
                        } px-3 py-2 text-sm font-semibold shadow-sm sm:col-start-1 sm:mt-0`}
                    >
                      No
                    </button>
                  </div>
                </DialogPanel>
              </div>
            </div>
          </Dialog>
          <Dialog
            open={deleteInfoMenuShow}
            onClose={setDeleteInfoMenuShow}
            className="relative z-10"
          >
            <DialogBackdrop
              transition
              className="fixed inset-0  transition-opacity data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in"
            />

            <div className="fixed inset-0 z-10 w-screen overflow-y-auto px-[4.7rem] pb-0">
              <div className="flex min-h-full w-1/6 items-end absolute px-20 justify-start p-4 text-center  sm:p-0">
                <DialogPanel
                  transition
                  className={`relative transform  rounded-lg shadow-black-2-shadow border border-solid ${themeMode === "dark"
                      ? "bg-[#2a2939] border-white-09"
                      : "bg-[#FFFFFF] border-black-09 "
                    } overflow-hidden rounded-lg   px-4 pb-4 pt-5 text-left shadow-xl transition-all data-[closed]:translate-y-4 data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in sm:my-4 sm:w-full sm:max-w-lg sm:p-6 data-[closed]:sm:translate-y-0 data-[closed]:sm:scale-95`}
                >
                  <div>
                    <div className="mt-0 text-start sm:mt-0">
                      <DialogTitle
                        as="h3"
                        className={`text-base font-semibold flex flex-row justify-start ${themeMode === "dark" ? "text-[#fff]" : "text-[#000]"
                          }`}
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          fill="none"
                          viewBox="0 0 24 24"
                          strokeWidth="1.5"
                          stroke="currentColor"
                          className="size-6"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            d="M9 12.75 11.25 15 15 9.75M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
                            fill="#008000"
                            stroke="#fff"
                          />
                        </svg>
                        Survey deleted
                      </DialogTitle>
                    </div>
                  </div>
                  <div className="flex-shrink-0 grid grid-flow-col rtl justify-end items-center gap-2 mt-2">
                    <button
                      type="button"
                      onClick={() => setDeleteInfoMenuShow(false)}
                      className={`mt-3 inline-flex justify-center rounded-[0.375rem] border-solid bg-[#205dc2] hover:bg-[#3575de] hover:text-white text-white  ${themeMode === "dark"
                        ? " border-white-09  "
                        : " border-black-09 "
                        } px-3 py-2 text-sm font-semibold shadow-sm sm:col-start-2 sm:mt-0`}
                    >
                      Ok
                    </button>
                  </div>
                </DialogPanel>
              </div>
            </div>
          </Dialog>

          <Dialog open={newSurveyDialog} onClose={setNewSurveyDialog} className="relative z-10">
            <DialogBackdrop
              transition
              className="fixed inset-0 transition-opacity data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in"
            />

            <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
              <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0 w-auto">
                <DialogPanel
                  transition
                  className={`relative md:w-[500px] sm:max-w-2xl w-auto transform rounded-lg bottom-[100px] ${themeMode === "dark" ? "bg-[#2a2939]" : "bg-white"
                    } px-4 pb-4 text-left shadow-xl transition-all ...`}
                >
                  <div className="pb-6 px-6 flex flex-col h-full items-stretch justify-start">
                    <div className="text-center sm:mt-5">
                      <DialogTitle
                        as="h3"
                        className={`text-base font-semibold flex align-center ${themeMode === "dark" ? "text-[#fff]" : "text-[#000]"
                          }`}
                      >
                        New Survey
                      </DialogTitle>
                      <Field className="mt-2 flex align-center">
                        <div className="flex flex-col flex-grow">
                          <div className="inline-flex flex-col items-start min-w-0 w-full">
                            <div className="font-normal text-[1.25rem] w-full min-w-0 min-h-0 flex items-center flex-nowrap">
                              <input
                                type="text"
                                value={newSurveyName}
                                onChange={(e) => setNewSurveyName(e.target.value)}
                                placeholder="Survey Name"
                                className={`w-full m-0 p-0 min-w-0 border-none rounded-[2px] font-inherit bg-transparent outline-none ${themeMode === "dark"
                                    ? "text-white"
                                    : "text-[#000]"
                                  }`}
                              />
                            </div>
                          </div>
                        </div>
                      </Field>
                    </div>
                  </div>
                  <div
                    className={`flex flex-row-reverse justify-between items-center border-t border-white/9 overflow-hidden flex-shrink-0 ltr p-4 h-[4.25rem] rounded-b-md ${themeMode === "dark" ? "border-white-09" : "border-black-09"
                      }`}
                  >
                    <div
                      className={`text-[0.75rem] grid grid-flow-col auto-cols-max justify-start items-center gap-3 flex-shrink-0`}
                    >
                      <button
                        className={`min-w-[5rem] flex-shrink-0 px-3 py-2 flex justify-center align-center border-solid border rounded-[0.375rem] h-[2.25rem] ${"text-[#fff] border-white-09 cursor-pointer hover:bg-[#3575DE] bg-[#205DC2]"
                          }`}
                        type="submit"
                        onClick={(e) => createNewSurvey(newSurveyName)}
                      >
                        <span
                          className={`whitespace-nowrap break-all text-ellipsis overflow-hidden min-w-0 pointer-events-none ${"text-[#fff]"
                            }`}
                        >
                          Create
                        </span>
                      </button>
                    </div>
                    <div className="buttons-group small-gap text-sm"></div>
                  </div>
                </DialogPanel>
              </div>
            </div>
          </Dialog>
          {/* <Dialog
            open={cloneInfoMenuShow}
            onClose={setCloneInfoMenuShow}
            className="relative z-10"
          >
            <DialogBackdrop
              transition
              className="fixed inset-0  transition-opacity data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in"
            />

            <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
              <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
                <DialogPanel
                  transition
                  className={`relative transform  rounded-lg shadow-black-2-shadow border border-solid ${themeMode === "dark"
                      ? "bg-[#2a2939] border-white-09"
                      : "bg-[#FFFFFF] border-black-09 "
                    } overflow-hidden rounded-lg   px-4 pb-4 pt-5 text-left shadow-xl transition-all data-[closed]:translate-y-4 data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in sm:my-8 sm:w-full sm:max-w-lg sm:p-6 data-[closed]:sm:translate-y-0 data-[closed]:sm:scale-95`}
                >
                  <div>
                    <div className="mt-0 text-start sm:mt-0">
                      <DialogTitle
                        as="h3"
                        className={`text-base font-semibold flex flex-row justify-start ${themeMode === "dark" ? "text-[#fff]" : "text-[#000]"
                          }`}
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          fill="none"
                          viewBox="0 0 24 24"
                          strokeWidth="1.5"
                          stroke="currentColor"
                          className="size-6"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            d="M9 12.75 11.25 15 15 9.75M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
                            fill="#008000"
                            stroke="#fff"
                          />
                        </svg>
                        Survey Cloned
                      </DialogTitle>
                    </div>
                  </div>
                  <div className="flex-shrink-0 grid grid-flow-col rtl justify-end items-center gap-2 mt-2">
                    <button
                      type="button"
                      onClick={() => setCloneInfoMenuShow(false)}
                      className={`mt-3 inline-flex justify-center rounded-[0.375rem] border-solid bg-[#205dc2] hover:bg-[#3575de] hover:text-white text-white  ${themeMode === "dark"
                          ? " border-white-09  "
                          : " border-black-09 "
                        } px-3 py-2 text-sm font-semibold shadow-sm sm:col-start-2 sm:mt-0`}
                    >
                      Ok
                    </button>
                  </div>
                </DialogPanel>
              </div>
            </div>
          </Dialog> */}
        </div>
      )}
      {/* {tabs.find((tab) => tab.name === homeSelectedTab)?.name !== "Surveys" && (
        <Routes>
          <Route path="q-robot" element={<QRobot />} />
          <Route path="create-from-file" element={<CreateFromFile />} />
          <Route path="benchmarked" element={<Benchmarked searchTerm={searchTerm} />} />
        </Routes>
      )} */}
        <Outlet  context={{ searchTerm, setSearchTerm }}/>
    </div>
  );
}
